/*global window*/

export const successAlert = (message, timeout = true) => {
  if (window && window.collage && window.collage.alertBox) {
    window.collage.alertBox('success', message, timeout);
  }
};

export const errorAlert = (message) => {
  if (window && window.collage && window.collage.alertBox) {
    window.collage.alertBox('error', message);
  }
};
